// Constants.
import * as StatsTableConstants from 'constants/StatsTableConstants';
import * as DashboardDatePickerConstants from 'constants/DashboardDatePickerConstants';
import * as PayProductsConstants from 'constants/PayProductsConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';

const initialState = {
  isFetching: false,
  isFetched: false,
  isFetchingExport: false,
  isFetchedExport: false,
  tableData: { results: [] },
  tableDataExport: {},
  page: 1,
  errorMessage: '',
};

export default function statsCharts(state = initialState, action = {}) {
  switch (action.type) {
    case StatsTableConstants.LOAD_STATS_TABLE_REQUEST:
      return {
        ...state,
        isFetched: false,
        isFetching: true,
        page: 1,
        tableData: { results: [] },
      };
    case StatsTableConstants.LOAD_STATS_TABLE_SUCCESS:
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        page: state.page + 1,
        tableData: Object.assign({}, state.tableData, { results: action.tableData.measurements }),
      };
    case StatsTableConstants.LOAD_STATS_TABLE_FAILURE:
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        page: 1,
        tableData: { results: [] },
        errorMessage: action.message,
      };
    case StatsTableConstants.LOAD_STATS_TABLE_MORE_REQUEST:
      return {
        ...state,
        isFetched: true,
        isFetching: true,
      };
    // case StatsTableConstants.LOAD_STATS_TABLE_MORE_SUCCESS:
    //   // state.tableData.results.pop();
    //   const results = state.tableData.results.concat(action.tableData.results);
    //   const tableData = Object.assign({}, state.tableData, action.tableData);
    //   tableData.count = state.tableData.count;
    //   tableData.results = results;
    //   return {
    //     ...state,
    //     isFetched: true,
    //     isFetching: false,
    //     page: state.page + 1,
    //     tableData: tableData,
    //   };
    case StatsTableConstants.LOAD_STATS_TABLE_EXPORT_REQUEST:
      return {
        ...state,
        isFetchedExport: false,
        isFetchingExport: true,
        tableDataExport: {},
      };
    case StatsTableConstants.LOAD_STATS_TABLE_EXPORT_SUCCESS:
      return {
        ...state,
        isFetchedExport: true,
        isFetchingExport: false,
        tableDataExport: action.tableDataExport,
      };
    case AuthConstants.LOGIN_SUCCESS:
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
    case DashboardDatePickerConstants.DASHBOARD_DATE_PICKER_CHANGE:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        isFetchedExport: false,
        isFetchingExport: false,
        page: 1,
        tableData: { count: 0, results: [] },
        tableDataExport: {},
      };
    default:
      return state;
  }
}
